<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="优惠券状态">
        <Select placeholder="全部状态" v-model="searchCondition.grant" style="width:200px" clearable>
          <Option v-for="item in statusList" :value="item.grant" :key="item.grant">{{ item.name }}</Option>
        </Select>
      </Form-item>
      <Form-item label="优惠券名称">
        <Input
          style="width:200px"
          placeholder="请输入优惠券名称关键字"
          v-model="searchCondition.name"
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" :to="{name: 'CouponEdit'}">新建优惠券</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/coupon"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            v-if="row.grant == 1"
            :to="{name: 'CouponDetail', query:{id: row.id}}"
          >查看-</Button>
          <Button type="text" size="small" @click="open(row)">{{action_btn[row.grant]}}-</Button>
          <Button
            type="text"
            size="small"
            :to="{name: row.grant == 0 ? 'CouponEdit':'CouponRecord', query:{id: row.id}}"
          >{{row.grant==0?"编辑":"领取记录"}}</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CouponManage",
  data() {
    return {
      column: [
        {
          title: "优惠券名称",
          key: "name",
          align: "center",
          minWidth: 200
        },
        {
          title: "使用范围",
          key: "scope_type_name",
          align: "center",
          minWidth: 200
        },
        {
          title: "有效期",
          key: "valid_value",
          align: "center",
          minWidth: 150
        },
        {
          title: "领取/发放",
          key: "draw_status",
          align: "center",
          minWidth: 150
        },
        {
          title: "状态",
          key: "grant_value",
          align: "center",
          minWidth: 100
        },
        {
          title: "类型",
          key: "receive_type_value",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right"
        }
      ],
      selectList: [],
      searchCondition: {
        name: "",
        grant: "",
        receive_type: "0"
      },
      scope_type_name: "",
      action_btn: ["发放", "结束发放", "查看"],
      position_status: "",
      statusList: [
        { grant: 0, name: "未发放" },
        { grant: 1, name: "领取中" },
        { grant: 2, name: "已结束" }
      ]
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        if (i.valid_type == 1) {
          i.valid_value = i.valid_day;
        } else {
          i.valid_value =
            this.$pub.timestampToDay(i.valid_start) +
            "~" +
            this.$pub.timestampToDay(i.valid_end);
        }
        i.grant_value =
          i.grant == 0 ? "未发放" : i.grant == 1 ? "领取中" : "已结束";
        i.draw_status = i.draw_num + "/" + i.num;
        i.receive_type_value = i.receive_type == 1 ? "领取" : "赠送";
        i.scope_type_name = this.$pub.getCouponUseRange(i.dis_type, i.scope_type);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
        this.searchCondition.grant = "";
      }
      this.$refs.grid.searchRefresh();
    },
    open(row) {
      if (row.grant == 0) {
        // 未发放
        this.$http.put(`/api/coupon/grant/${row.id}`).then(() => {
          this.search(1);
        });
      } else if (row.grant == 2) {
        //查看
        this.$router.push({
          name: "CouponDetail",
          query: {
            id: row.id
          }
        });
      } else {
        //结束发放
        this.$http.put(`/api/coupon/finishGrant/${row.id}`).then(() => {
          this.search(1);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
